import {Injectable} from '@angular/core';
import {NetworkService} from '../network/network.service';
import {PrivilegeModel} from '../../models/user-session.model';
import {Link} from '../../models/link.model';
import {Observable} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {HttpUrlEncodingCodec} from '../authorization/http-url-encoding-codec';

export interface AccountModel {
  organizationList?: any;
  email?: string;
  firstName?: string;
  id: string;
  lastName?: string;
  links?: Link[];
  name: string;
  privilege?: PrivilegeModel;
  userName: string;
  phoneNumber?: string;
  isWalgreensUser?: boolean;
  organizationIds?:any;
  additionalOrganizations?: any;
  emailAddress?: any;
  additionalLocationCount: any;
  locationNumber?: any;
  locationType?: string;
  role?: string;
  pharmacistNPI?: string;
  gender?: string;
  dateOfBirth?: number;
}

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private _apiUrl = `/api/accounts`;

  constructor(private networkService: NetworkService) {}

  createAccount(body): Observable<AccountModel> {
    return this.networkService.postResource<AccountModel>(this._apiUrl, body);
  }

  updateAccount(id, body): Observable<AccountModel> {
    return this.networkService.putResource<AccountModel>(`${this._apiUrl}/${id}`, body);
  }

  updateAccountWithSecondaryStores(id, body, organizationIds): Observable<AccountModel> {
    return this.networkService.putResource<AccountModel>(`${this._apiUrl}/${id}`, body);
  }

  updateAccountOrganization(accountId, newOrganizationId): Observable<AccountModel> {
    // reassign User clinic
    return this.networkService.putResource(`${this._apiUrl}/${accountId}`, {organizationId: newOrganizationId});
  }

  reassignUserToOrganization(accountId, newOrganizationId): Observable<AccountModel> {
    let url = `${this._apiUrl}/${accountId}/${newOrganizationId}`
    return this.networkService.putResource(url, {});
  }

  getAccount(id): Observable<any> {
    return this.networkService.fetchResource(`${this._apiUrl}/${id}`);
  }

  checkIfExisting(email: string): Observable<any> {
    const url = `/api/accounts/exist`;
    const httpParams = new HttpParams({encoder: new HttpUrlEncodingCodec()}).set('email', email);

    return this.networkService.fetchResource(url, {params: httpParams});
  }

  showError(error, defaultMessage) {
    let errorMessage = defaultMessage;

    if (error.error) {
      const message = error.error.message;
      if (message.includes('exists with same') || message.includes('already exist')) {
        errorMessage = message;
      }
    }

    return errorMessage
  }

  addLocationAndArea(accountId, body, location, type): Observable<any> {
    const url = `/api/accounts/${accountId}/updatePrimaryLocation?locationNumber=${location}&locationType=${type}`;
    return this.networkService.putResource<any>(url,body);
  }
}
